import * as Sentry from "@sentry/sveltekit";

const myErrorHandler = ({ error, event }: { error: any; event: any }) => {
  console.error("An error occurred on the client side:", error, event);
};

export const handleError = Sentry.handleErrorWithSentry(myErrorHandler);
